// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Fl-z","tupacHeader":"Gl-z","tupacHeader2":"Hl-z","tupacMenu":"Il-z","tupacMenu2":"Jl-z","tupacMain":"Kl-z","tupacMain2":"Ll-z"};